import { useTranslate } from '@tolgee/react';
import { QUICK_ACTIONS } from './constants';
import {
  resetAIConversation,
  sendAiAssistantQuickAction,
  setmessageSettingsAttributes,
  updateAiAssistantUiAttribute
} from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

export const QuickActions: React.FC<any> = (props) => {
  // on component unmount set showActionOptions to false
  useEffect(() => {
    return () => {
      dispatch(
        updateAiAssistantUiAttribute({
          attribute: 'showActionOptions',
          value: false
        })
      );
    };
  }, []);
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const {
    aiAssistant: {
      ui: { showActionOptions }
    },
    platformEnabled
  } = useSelector((state: any) => state.lomavisCreator);
  const [actionOptions, setActionOptions] = useState<{
    action: any | null;
    playloadField: string | null;
    options: any | null;
  }>(null);
  return (
    <div className="card p-4 h-100">
      <h4 className="w-100 text-center">
        {t('lomavisCreator.aiAssistant.quickActions')}
      </h4>
      <div className="d-flex flex-column h-100">
        {!showActionOptions && (
          <div className="mb-3 row mt-5 d-flex flex-column justify-content-between h-100">
            <div>
              {QUICK_ACTIONS.map((action) => (
                <div
                  key={action.name}
                  className="col-12 cursor-pointer border rounded p-3 mb-2"
                  onClick={() => {
                    // only trigger if action has no options
                    if (!action.options) {
                      dispatch(sendAiAssistantQuickAction(action) as any);
                    } else {
                      // open new view for options
                      setActionOptions({
                        action,
                        playloadField: action?.playloadField,
                        options: action?.options
                      });
                      dispatch(
                        updateAiAssistantUiAttribute({
                          attribute: 'showActionOptions',
                          value: true
                        })
                      );
                    }
                  }}
                >
                  <div className="d-flex align-items-center">
                    <i className={`fa-solid ${action.icon} me-2`}></i>
                    <span>{t(action.name)}</span>
                    {action.options && (
                      <i className="fa-solid fa-greater-than ms-auto"></i>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div>
              <button
                className="btn btn-secondary btn-sm mt-3 w-100"
                onClick={() => dispatch(resetAIConversation() as any)}
              >
                {t('lomavisCreator.aiAssistant.resetConversation')}
              </button>
            </div>
          </div>
        )}
        {showActionOptions && (
          <div className="mb-3 row mt-5 h-100 d-flex flex-column justify-content-between">
            <div>
              {actionOptions?.options
                ?.filter((option) => option.key !== 0)
                .map((option) => {
                  if (
                    (actionOptions.action.checkEnabledPlatforms &&
                      platformEnabled[option.key]) ||
                    !actionOptions.action.checkEnabledPlatforms
                  )
                    return (
                      <div
                        key={option.name}
                        className="col-12 cursor-pointer border rounded p-3 mb-2"
                        onClick={() => {
                          const executeSequentially = async () => {
                            // 1. First update settings
                            await Promise.resolve(
                              dispatch(
                                setmessageSettingsAttributes({
                                  [actionOptions.playloadField]: option.key
                                })
                              )
                            );

                            // 2. Then send quick action and wait for completion
                            await new Promise<void>((resolve) => {
                              dispatch(
                                sendAiAssistantQuickAction(
                                  actionOptions.action
                                ) as any
                              );
                              resolve();
                            });

                            // 3. Clear action options
                            setActionOptions(null);

                            // 4. Finally update UI attribute
                            await Promise.resolve(
                              dispatch(
                                updateAiAssistantUiAttribute({
                                  attribute: 'showActionOptions',
                                  value: false
                                })
                              )
                            );
                          };

                          executeSequentially().catch(console.error);
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <span>{t(option.label)}</span>
                        </div>
                      </div>
                    );
                })}
            </div>

            <div>
              <div className="mt-auto" />
              <button
                className="btn btn-secondary w-100 btn-sm mt-3"
                onClick={() => {
                  setActionOptions(null);
                  dispatch(
                    updateAiAssistantUiAttribute({
                      attribute: 'showActionOptions',
                      value: false
                    })
                  );
                }}
              >
                {t('lomavisCreator.aiAssistant.back')}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
